import constants, { ACCESS_TOKEN, HTTP_METHODS } from "../../../settings/shared/constants"
import axiosClient from "../../common"

function _constructHeader() {
    let jwtToken = localStorage.getItem(ACCESS_TOKEN);
    let headers = {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + jwtToken
    }
    return headers;
}

function getAccountCreditUsageSummary() {
    return axiosClient({
        url: constants.api.billing.getAccountCreditUsageSummary,
        method: HTTP_METHODS.GET,
        headers: _constructHeader()
    })
}

function getAccountCreditUsage(type, opts = {}) {
    return axiosClient({
        url: constants.api.billing.getAccountCreditUsage,
        method: HTTP_METHODS.GET,
        headers: _constructHeader(),
        params: { type, ...opts }
    })
}

function getProjectCreditUsageSummary(projectId) {
    return axiosClient({
        url: constants.api.billing.getProjectCreditUsageSummary + "/" + projectId,
        method: HTTP_METHODS.GET,
        headers: _constructHeader()
    })
}

function getProjectCreditUsage(projectId, type, opts = {}) {
    return axiosClient({
        url: constants.api.billing.getProjectCreditUsage + "/" + projectId,
        method: HTTP_METHODS.GET,
        headers: _constructHeader(),
        params: { type, ...opts }
    })
}

function getTrialUsageSummary() {
    return axiosClient({
        url: constants.api.billing.getTrialUsageSummary,
        method: HTTP_METHODS.GET,
        headers: _constructHeader()
    })
}

//To export run function
const BillingService = {
    getAccountCreditUsage,
    getAccountCreditUsageSummary,
    getProjectCreditUsage,
    getProjectCreditUsageSummary,
    getTrialUsageSummary,
}
export default BillingService;
